import React, { useState, useEffect, useContext } from 'react';

import './WishlistButton.css';

const wishlistIcon = 'https://cdn.obsess-vr.com/ferragamo/menu/Wishlist_save.svg';

// TODO: PASS IN CART PAGE URL, CART TEXT STYLE, AND CART TEXT AS PROPS
const WishlistButton = ({ onClick, itemCount }) => {
    return (
        <div className='wishlist-button-container flex-center hoverable' onClick={itemCount > 0 ? onClick : ""}>
            <div className='wishlist-icon-container flex-center'>
                <img className='wishlist-icon' src={wishlistIcon} />
                {(itemCount > 0) && <span className='item-count-wishlist'>{itemCount}</span>}
            </div>
            {/* <span className='wishlist-button-text'>Wishlist</span> */}
        </div>
    )
}

export default WishlistButton;